import React, { useState, useRef } from "react";
import Pagination from "../../../Utils";
import { useQuery } from "@tanstack/react-query";
import { GetPopularQuizzes } from "../../../Api/analytics";
import { ErrorToast } from "../../../Utils/SweetAlert";
import noImage from "../../../assets/Images/no-image.png";

const PopularQuizTable = ({ searchQuery }) => {
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [sortBy, setSortBy] = useState("count");
    const [sortOrder, setSortOrder] = useState("desc");

    const { data: quizData, isFetching: loading } = useQuery({
        queryKey: ["get-popular-quizzes", page, limit, searchQuery, sortBy, sortOrder],
        queryFn: () => {
            return GetPopularQuizzes({
                page: page + 1,
                limit,
                search: searchQuery || "",
                sortBy,
                sortOrder,
            });
        },
        throwOnError: (error) => {
            ErrorToast(error?.response?.data?.message || "Server Error.");
        },
    });

    const handlePageChange = (e, newPage) => setPage(newPage);
    const handleLimitChange = (e) => {
        setLimit(parseInt(e.target.value, 10));
        setPage(0);
    };

    const handleSort = (field) => {
        if (sortBy === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortBy(field);
            setSortOrder("desc");
        }
        setPage(0);
    };

    const renderSortIcon = (field) => {
        if (sortBy !== field) return <span style={{ opacity: 0.3, marginLeft: '5px' }}>↕</span>;
        return sortOrder === "asc" ? <span style={{ marginLeft: '5px' }}>↑</span> : <span style={{ marginLeft: '5px' }}>↓</span>;
    };

    const handleImageError = (event) => {
        event.target.src = noImage;
    };

    return (
        <div className="col-sm-12 table-width">
            <div className="cards-table card-table">
                <div className="card-body">
                    <div className="table-responsive custom-pagination">
                        <table className="table datatable table-manager mb-0 table-no-padding" style={{ width: '100%' }}>
                            <thead className="thead-light">
                                <tr>
                                    <th className="text-start" style={{ width: '15%' }}>Icon</th>
                                    <th className="text-start" style={{ width: '60%' }}>Title</th>
                                    <th className="text-start" style={{ width: '25%', cursor: 'pointer' }} onClick={() => handleSort('count')}>User Count {renderSortIcon('count')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading && (
                                    <tr>
                                        <td align="center" colSpan={3}>
                                            <div className="d-flex justify-content-center align-items-center py-4">
                                                <div className="spinner-border loader-theme" role="status" />
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {!loading && quizData?.data?.mostUsed && (
                                    <>
                                        {quizData.data.mostUsed.map((item, index) => (
                                            <tr key={index} className="table border-bottom">
                                                <td className="text-start">
                                                    <img
                                                        src={item.icon}
                                                        alt={item.title}
                                                        width={40}
                                                        height={40}
                                                        style={{ borderRadius: '5px' }}
                                                        onError={handleImageError}
                                                    />
                                                </td>
                                                <td className="text-start">{item.title}</td>
                                                <td className="text-start">{item.count || 0}</td>
                                            </tr>
                                        ))}
                                    </>
                                )}
                                {!loading && (!quizData?.data?.mostUsed || quizData?.data?.mostUsed.length === 0) && (
                                    <tr><td colSpan={3} className="text-center">No Records Found.</td></tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <Pagination
                totalItem={quizData?.data?.totalRecords || 0}
                itemsPerPage={limit}
                page={page}
                handleChangePage={handlePageChange}
                handleChangeRowsPerPage={handleLimitChange}
            />
        </div>
    );
};

export default PopularQuizTable;
